//TABLE 3 WITH 3 ROWS AND 6 COLUMNS (BASE METAL THICKNESS)
import { Table } from "react-bootstrap";
import { Tooltip_detail as Tooltip } from "../../utility/common/helpers/Tooltip";
import Error from "../../../icons/ErrorIcon.svg";
import { isAlphanumericWithPlusandEqualsPlusMinus } from "../../../functions/validations";
import PropTypes from "prop-types";

export const WpqJointDetailtable1A = ({
  headerObj,
  readOnly,
  name,
  maxLength,
  handleActualValueChange,
  handleRangeQualifiedChange,
  ColumnHeader,
  isTubsheetRow,
  error,
  setError,
  disableFields
}) => {

  WpqJointDetailtable1A.propTypes = {
    headerObj: PropTypes.array,
    name: PropTypes.array,
    maxLength: PropTypes.number,
    handleRangeQualifiedChange: PropTypes.func,
    handleActualValueChange: PropTypes.func,
    ColumnHeader: PropTypes.array,
    isTubsheetRow: PropTypes.bool,
    error: PropTypes.array,
    setError: PropTypes.func,
    readOnly: PropTypes.bool,
  }

  return (
    <Table className="text-center ">
      <thead>
        <tr className="border thead-color ">
          <th className=" border thickness_title" style={{ width: "31%" }}></th>
          <th className="thickness_title">Actual Value</th>
          <th className="thickness_title">Range Qualified</th>
        </tr>
      </thead>

      <tbody>
        {
          isTubsheetRow &&
          <tr className={"border WpsInput-md"}>
            <th className={"text-start thead-color"}>
              <div>
                Joint Type
              </div>
            </th>
            <td>
              <input
                style={{
                  marginRight: "10px",
                  marginLeft: "10px",
                  position: "relative",
                  width: "142px",
                  left: "93px"
                }}
                key={0}
                type="text"
                name={"WPQ_Joint_Type"}
                readOnly
                disabled={disableFields}
                value="Tube to Tubesheet"
              />
            </td></tr>
        }
        {name?.map((element, id) => {
          console.log("element", element, headerObj[element], headerObj)
          let status1 = error[element]?.[0]?.Actual_Value?.[0]?.status;
          let status2 = error[element]?.[1]?.Range_Qualified?.[0]?.status;
          let message1 = error[element]?.[0]?.Actual_Value?.[0]?.message;
          let message2 = error[element]?.[1]?.Range_Qualified?.[0]?.message;

          return (
            <tr
              className={`border WpsInput-md${status1 || status2 ? ' error' : ''}`}
              key={`tr-${element}`}
            >
              <th className={"text-start thead-color"}>
                <div>
                  {ColumnHeader[id]}
                  {(status1 || status2) && (
                    <Tooltip content={message1 || message2}>
                      <img src={Error} alt="Error" className="ms-1" />
                    </Tooltip>
                  )}
                </div>
              </th>
              <td>
                <div>
                  {headerObj[element]?.[0]?.Actual_Value && (
                    <input
                      style={{
                        marginRight: "10px",
                        marginLeft: "10px",
                        width: "110px",
                      }}
                      type="text"
                      name={element}
                      maxLength={maxLength}
                      readOnly={readOnly}
                      disabled={disableFields}
                      value={headerObj[element][0].Actual_Value[0]}
                      onChange={(e) =>
                        handleActualValueChange(element, 0, 0, e.target.value)
                      }
                      onInput={(e) => {
                        let error = isAlphanumericWithPlusandEqualsPlusMinus(
                          e.target.value
                        );
                        setError((prevState) => ({
                          ...prevState,
                          [element]: [
                            { Actual_Value: [error] },
                            { Range_Qualified: [error] },
                          ],
                        }));
                      }}
                    />
                  )}
                </div>
              </td>

              <td>
                {headerObj[element]?.[1]?.Range_Qualified &&
                  <input
                    style={{
                      marginRight: "10px",
                      marginLeft: "10px",
                      width: "110px",
                    }}

                    name={element}
                    readOnly={readOnly}
                    disabled={disableFields}
                    maxLength={maxLength}
                    type="text"
                    value={headerObj[element][1].Range_Qualified[0]}
                    onChange={(e) =>
                      handleRangeQualifiedChange(
                        element,
                        1,
                        0,
                        e.target.value
                      )
                    }
                    onInput={(e) => {
                      let error = isAlphanumericWithPlusandEqualsPlusMinus(
                        e.target.value
                      );
                      setError((prevState) => ({
                        ...prevState,
                        [element]: [
                          { Actual_Value: [error] },
                          { Range_Qualified: [error] },
                        ],
                      }));
                    }}
                  />

                }
              </td>
            </tr>
          )
        })}
      </tbody>
    </Table>
  );
};
